import { render, staticRenderFns } from "./DocumentEditDetail.vue?vue&type=template&id=0d3dfbca&"
import script from "./DocumentEditDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentEditDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports